var React = require('react');

function VideoPlayButton (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"57","cy":"57","r":"56","fill":"current","fillOpacity":"0.8","stroke":"#30E4BE","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M48.3333 41.834V72.1673L72.1667 57.0007L48.3333 41.834Z","fill":"white","key":1})]);
}

VideoPlayButton.defaultProps = {"viewBox":"0 0 114 114","fill":"none"};

module.exports = VideoPlayButton;

VideoPlayButton.default = VideoPlayButton;
